module.exports = __webpack_public_path__ + "static/media/lg.14d43789.svg";